import { formatTimerClock } from '../../lib/timerClockFormat';

/** Keep the animation node stable while its countdown text changes. */
export function TimerMarquee({
  text,
  breakSeconds,
  size,
  color,
}: {
  text: string;
  breakSeconds: number | null;
  size: number;
  color: string;
}) {
  if (!text && breakSeconds === null) return null;
  return (
    <>
      <style>{`@keyframes timer-marquee-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      .animate-marquee { display: flex; width: max-content; animation: timer-marquee-scroll 25s linear infinite; }`}</style>
      <div className="animate-marquee whitespace-nowrap" data-timer-marquee>
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" data-marquee-cycle>
            {text && (
              <span className="font-bold mx-8" style={{ fontSize: size, color }}>
                {text}
              </span>
            )}
            {breakSeconds !== null && (
              <span
                className="font-bold mx-8"
                style={{ fontSize: size, color, fontVariantNumeric: 'tabular-nums' }}
              >
                Break in {formatTimerClock(breakSeconds)}
              </span>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
